import React from 'react';
import { TouchableOpacity } from 'react-native';
import { YStack } from 'tamagui';
import { Lesson } from '../types';
import { SectionTitle } from './ui/Typography';
import { SuggestedLessonCard } from './ui/SuggestedLessonCard';

interface LessonSuggestionsProps {
  suggestions: Lesson[];
  onSuggestionPress?: (lesson: Lesson) => void;
}

export const LessonSuggestions: React.FC<LessonSuggestionsProps> = ({
  suggestions,
  onSuggestionPress
}) => {
  if (!suggestions || suggestions.length === 0) {
    return (
      <YStack w="100%" f={1} ai="center" jc="center" py={24} px={24}>
        <SectionTitle fontWeight="500" color="#2B2B2B" ta="center">
          Go to the course page to explore what’s next for you.
        </SectionTitle>
      </YStack>
    );
  }

  return (
    <YStack w="100%" gap="$2">
      <SectionTitle color="#1E1E1E">
        Up Next
      </SectionTitle>

      {suggestions.map((lesson) => (
        <TouchableOpacity key={lesson.id} onPress={() => onSuggestionPress?.(lesson)}>
          <SuggestedLessonCard item={lesson} />
        </TouchableOpacity>
      ))}
    </YStack>
  );
};
